import React from "react";
import { MdDashboard } from "react-icons/md";
import CustomHeading from "../Extra/CustomHeading";
import { BiSolidDashboard } from "react-icons/bi";
const DashBoardNavbar = () => {
  return (
    <div className=" m-0 p-0 ">
      {/* <h2 className="d-flex align-items-center justify-content-center">
        <MdDashboard />
        DashBoard
      </h2> */}
      <CustomHeading
        text={{
          heading: "Dashboard",
          subText: "Management System",
        }}
        icon={BiSolidDashboard}
        style={{
          height: "100px",

          // Main container
          width: "100%",
          borderRadius: "24px",
          shadow: "0 10px 30px rgba(0,0,0,0.15)",
          background: "#fff",

          // Gradient
          gradient: true,
          color: ["#063b87", "#0a57bb", "#087344"],
          gradientDirection: "120deg",

          // Heading
          headingColor: "#ffffff",
          headingSize: "clamp(2rem, 5vw, 3.5rem)",
          headingWidth: "520px",

          // Subtitle
          subtitleColor: "#f4f7fb",
          subtitleSize: "0.95rem",
          subtitleMaxWidth: "650px",
          subtitleLineHeight: 1.5,

          // Content
          contentGap: "4px",

          // Decorations
          showGlow: true,
          showRailway: true,
          decorationOpacity: 0.18,

          // Railway
          railwayWidth: "220px",
          railwayTop: "20px",
          railwayRight: "30px",
        }}
      />
    </div>
  );
};
export default DashBoardNavbar;
